(function () {
  function initPlpProductGallery(gallery) {
    if (!gallery || gallery.dataset.galleryInit === 'true') return;

    var track = gallery.querySelector('.plp-gallery-track');
    var prevBtn = gallery.querySelector('.plp-gallery-nav--prev');
    var nextBtn = gallery.querySelector('.plp-gallery-nav--next');
    var dots = gallery.querySelectorAll('.plp-gallery-dot');

    if (!track || !prevBtn || !nextBtn) return;

    gallery.dataset.galleryInit = 'true';

    function getSlideWidth() {
      return track.clientWidth || 1;
    }

    function getMaxScroll() {
      return Math.max(0, track.scrollWidth - track.clientWidth);
    }

    function getActiveDotIndex() {
      var maxScroll = getMaxScroll();
      if (maxScroll <= 0) return 0;

      var progress = track.scrollLeft / maxScroll;
      if (progress < 0.34) return 0;
      if (progress < 0.67) return 1;
      return 2;
    }

    function setActiveDot(index) {
      if (!dots.length) return;

      dots.forEach(function (dot, dotIndex) {
        var isActive = dotIndex === index;
        dot.classList.toggle('is-active', isActive);
        dot.setAttribute('aria-selected', isActive ? 'true' : 'false');
      });
    }

    function updateGalleryState() {
      var maxScroll = getMaxScroll();
      prevBtn.disabled = track.scrollLeft <= 1;
      nextBtn.disabled = track.scrollLeft >= maxScroll - 1;
      setActiveDot(getActiveDotIndex());
    }

    function scrollToDot(dotIndex) {
      var maxScroll = getMaxScroll();
      var targets = [0, maxScroll / 2, maxScroll];
      track.scrollTo({
        left: targets[dotIndex] || 0,
        behavior: 'smooth'
      });
    }

    function scrollBySlide(direction) {
      var slideWidth = getSlideWidth();
      track.scrollBy({
        left: slideWidth * direction,
        behavior: 'smooth'
      });
    }

    prevBtn.addEventListener('click', function (event) {
      event.preventDefault();
      event.stopPropagation();
      scrollBySlide(-1);
    });

    nextBtn.addEventListener('click', function (event) {
      event.preventDefault();
      event.stopPropagation();
      scrollBySlide(1);
    });

    dots.forEach(function (dot) {
      dot.addEventListener('click', function (event) {
        event.preventDefault();
        event.stopPropagation();
        var index = parseInt(dot.getAttribute('data-dot-index'), 10);
        if (!isNaN(index)) {
          scrollToDot(index);
        }
      });
    });

    track.addEventListener('scroll', updateGalleryState, { passive: true });
    window.addEventListener('resize', updateGalleryState);
    updateGalleryState();

    var hoverEnabled = window.matchMedia('(hover: hover) and (pointer: fine)').matches;
    if (hoverEnabled) {
      var viewport = gallery.querySelector('.plp-gallery-viewport');
      var slides = track.querySelectorAll('.plp-gallery-slide');

      if (viewport && slides.length >= 2) {
        var secondImg = slides[1].querySelector('img');
        var overlaySrc = secondImg && (secondImg.src || secondImg.dataset.src);

        if (overlaySrc && overlaySrc.indexOf('icon-loader') === -1) {
          var overlay = document.createElement('img');
          overlay.className = 'plp-hover-fade-overlay';
          overlay.src = overlaySrc;
          overlay.setAttribute('aria-hidden', 'true');
          overlay.setAttribute('alt', '');
          viewport.appendChild(overlay);

          var isHoverActive = false;

          gallery.addEventListener('mouseenter', function () {
            isHoverActive = true;
            // Move track silently to slide 2 so arrows start from the right position
            track.scrollLeft = getSlideWidth();
            updateGalleryState();
            overlay.classList.add('is-visible');
          });

          gallery.addEventListener('mouseleave', function () {
            isHoverActive = false;
            overlay.classList.remove('is-visible');
            // Reset track to slide 1 for next hover
            track.scrollLeft = 0;
            updateGalleryState();
          });

          function dismissOverlay() {
            if (!isHoverActive) return;
            isHoverActive = false;
            // Instantly hide overlay — user takes manual control of the track
            overlay.style.transition = 'none';
            overlay.classList.remove('is-visible');
            requestAnimationFrame(function () {
              overlay.style.transition = '';
            });
          }

          prevBtn.addEventListener('click', dismissOverlay);
          nextBtn.addEventListener('click', dismissOverlay);
          dots.forEach(function (dot) {
            dot.addEventListener('click', dismissOverlay);
          });
        }
      }
    }
  }

  function initPlpProductGalleries(root) {
    var scope = root && root.querySelectorAll ? root : document;
    scope.querySelectorAll('.js-plp-gallery:not([data-gallery-init="true"])').forEach(initPlpProductGallery);
  }

  window.theme = window.theme || {};
  theme.initPlpProductGalleries = initPlpProductGalleries;

  document.addEventListener('DOMContentLoaded', function () {
    initPlpProductGalleries(document);

    var productGrid = document.getElementById('product-grid');
    if (productGrid && typeof MutationObserver !== 'undefined') {
      new MutationObserver(function () {
        initPlpProductGalleries(productGrid);
      }).observe(productGrid, { childList: true, subtree: true });
    }
  });
})();
